import React from 'react';
import Ad from '@ifeng-fe/ui_pc_ad';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import auth from '@ifeng-fe/ui_pc_auth';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    handleTouchLogin = () => {
        if (auth.isLogin()) {
            // console.log('1111');

            return;
        } else {
            window.location.href = `//id.ifeng.com/muser/login?id=5&cb=${encodeURI(location.href)}`;
        }
    };

    render() {
        const { content } = this.props;

        return (
            <header className={styles.header}>
                <div className={styles.logo}>
                    <a href="http://v.ifeng.com/m/index.shtml" title="凤凰视频">
                        凤凰视频
                    </a>
                </div>
                <div className={styles.userWrapper}>
                    <a href="javascript:void(0);" onTouchStart={this.handleTouchLogin} />
                </div>
            </header>
        );
    }
}

export default errorBoundary(Header);
